import { ApiPath } from 'enums';
import env from 'environments/env';
import { Get } from 'utils';

export const getCustomers = async ({ ...query }) => {
  const res = await Get(`${ApiPath.Customer}/account`, query, null, env.API_URL_CMMS);
  return res.data;
};
